import { Link } from 'react-router-dom';
export default function Footer() {
  return (
    <>
<footer id="s-foot">
  <div className="container">
    <div className="foot-grid">
      <div className="foot-brand">
        <img src="/assets/logo-teamgrid-dark-text.svg" alt="TeamGrid" />
        <p>The organizational brain for modern companies. Patterns, not surveillance.</p>
      </div>
      <div className="fcol">
        <h4>Features</h4>
        <Link to="/features/ask-teamgrid">Ask TeamGrid</Link>
        <Link to="/features/automatic-time-tracking">Automatic Time Tracking</Link>
        <Link to="/features/productivity-scoring">Productivity Scoring</Link>
        <Link to="/features/ai-work-summaries">AI Work Summaries</Link>
        <Link to="/features/app-website-tracking">App &amp; Website Tracking</Link>
        <Link to="/features/hourly-breakdown">Hourly Breakdown</Link>
        <Link to="/features/org-intelligence">Org Intelligence</Link>
        <Link to="/features">All features →</Link>
      </div>
      <div className="fcol">
        <h4>Solutions</h4>
        <Link to="/solutions/remote-team-productivity">Remote Teams</Link>
        <Link to="/solutions/hr-staffing-firms">HR &amp; Staffing Firms</Link>
        <Link to="/solutions/accounting-firm-productivity">Accounting Firms</Link>
        <Link to="/solutions/bpo-shared-services">BPO &amp; Shared Services</Link>
        <Link to="/solutions/client-driven-work">Client-Driven Teams</Link>
        <Link to="/solutions/project-based-teams">Project-Based Teams</Link>
        <Link to="/solutions">All solutions →</Link>
      </div>
      <div className="fcol">
        <h4>Product</h4>
        <Link to="/monitoring">Monitoring</Link>
        <Link to="/pattern-intelligence">Pattern Intelligence</Link>
        <Link to="/crm">CRM</Link>
        <Link to="/hrms">HRMS</Link>
        <Link to="/email-insights">Email Insights</Link>
        <Link to="/resource-optimizer">Managed Services</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/download/all">Download</Link>
      </div>
      <div className="fcol">
        <h4>Compare</h4>
        <Link to="/compare/teamgrid-ai-vs-time-doctor">vs Time Doctor</Link>
        <Link to="/compare/teamgrid-ai-vs-hubstaff">vs Hubstaff</Link>
        <Link to="/compare/teamgrid-ai-vs-activtrak">vs ActivTrak</Link>
        <Link to="/compare/teamgrid-ai-vs-insightful">vs Insightful</Link>
        <Link to="/compare/teamgrid-ai-vs-we360-ai">vs We360.ai</Link>
        <Link to="/compare/teamgrid-ai-vs-prohance">vs ProHance</Link>
        <Link to="/compare">All comparisons →</Link>
      </div>
      <div className="fcol">
        <h4>Company</h4>
        <Link to="/about">About Us</Link>
        <Link to="/careers">Careers</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/partners">Partners</Link>
        <Link to="/contact">Contact Us</Link>
        <Link to="/book-demo">Book a Demo</Link>
        <Link to="/help">Docs &amp; Support</Link>
        <Link to="/security">Security</Link>
      </div>
    </div>
    <div className="foot-seo">Looking for a specific tool? TeamGrid is your <Link to="/monitoring">productivity tracking software</Link>, <Link to="/employee-monitoring-software">employee monitoring software</Link> (the privacy-first kind), <Link to="/time-tracking-software">time tracking software</Link>, <Link to="/hrms">HRMS</Link>, <Link to="/crm">CRM</Link>, <Link to="/email-insights">email tracker</Link> and <Link to="/features/project-tracking">goals &amp; task platform</Link> — all in one organizational brain.</div>
    <div className="foot-bottom">
      <span>© 2026 TeamGrid. All rights reserved.</span>
      <div className="legal">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/security">Security</Link>
        <Link to="/partner-login">Partner Login</Link>
      </div>
    </div>
  </div>
</footer>
    </>
  );
}
